import gql from 'graphql-tag';

const VideoThumbnailQuery = gql`
  query VideoThumbnailQuery($id: String!) {
    OnDemandLectureVideosV1 @naptime {
      get(id: $id, includes: "video") {
        elements {
          id
          videoId
        }
        linked {
          onDemandVideosV1 {
            sources {
              byResolution
            }
          }
        }
      }
    }
  }
`;
export default VideoThumbnailQuery;
